// import './font-loading'
import { send_event } from './analytics.js'
import 'jquery'
// import './nav-menu'
import 'slick-carousel'
// import './block-accordion'
// import './block-content-list'
// import 'bootstrap/dist/js/bootstrap.esm.js'
// import 'bootstrap/js/dist/util'
import 'bootstrap/js/src/collapse'
// import 'bootstrap/js/dist/dropdown'
import 'bootstrap/js/dist/modal'
import 'bootstrap/js/dist/tab'
import {addCustomEventListener} from './viewport-triggers'
import {getFadeUpAnimationGroups, doFadeUpAnimationGroup} from './animation-fade-up.js'
import "./quote-slider.js"
;(function($) {
    // Sliders
    // $(function() {
    //     $('.rs-slider .rs-slider-contain').slick({
    //         // dots: true,
    //         arrows: true,
    //         autoplay: true
    //     })

    //     // Calendar slider
    //     $('.tickets-calendar').slick({
    //         arrows: true,
    //         autoplay: false,
    //         infinite: false
    //     })

    // })

    $(function() {
        $('[data-aka-toggle-class]').each(function(button) {
            let isModal = $(this).data('bs-toggle') == 'modal'
            // let target = $($(this).data('aka-toggle-target'))
            let target = $(this)
            let toggleClass = target.data('aka-toggle-class')
            if (isModal) {
                $($(this).data('bs-target')).on('show.bs.modal', function() {
                    target.addClass(toggleClass)
                })
                $($(this).data('bs-target')).on('hide.bs.modal', function() {
                    target.removeClass(toggleClass)
                })
            }
        })
    });
})(jQuery)

window.addEventListener('DOMContentLoaded', function () {
    let groups = getFadeUpAnimationGroups();

    for (let group of groups) {
        let firstNode = group;
        if (Array.isArray(group)) {
            firstNode = group[0];
        }
        addCustomEventListener(firstNode, 'enterviewport', function (e) {
            doFadeUpAnimationGroup(group, 200, 1000)
        })
    }
})

document.addEventListener('DOMContentLoaded', function() {
    const keyartElt = document.querySelector('.keyart')
    if (!keyartElt) return;

    const videoContainer = keyartElt.querySelector('.keyart__vimeo')
    if (videoContainer) {
        setKeyartVideo(videoContainer);
    }
    const imageContainer = document.querySelector('.keyart__video-placeholder')
    if (imageContainer) {
        setKeyartImage(imageContainer);
    }


    window.addEventListener('resize', debounce(function() {
        setKeyartVideo(videoContainer)
        setKeyartImage(imageContainer)
    }));
});

function setKeyartVideo(videoContainer) {
    let isMobileViewport = jQuery(document).width() < 768;
    const desktopVideoTemplate = document.querySelector('#keyart-video-desktop')
    const mobileVideoTemplate = document.querySelector('#keyart-video-mobile')
    // console.log(isMobileViewport, videoContainer.src, videoContainer.srcset);
    if (isMobileViewport && !videoContainer.classList.contains('keyart__vimeo--mobile')) {
        // console.debug('Setting keyart video - mobile')
        videoContainer.innerHTML = "";
        videoContainer.append(mobileVideoTemplate.content.cloneNode(true));
        videoContainer.classList.remove('keyart__vimeo--desktop');
        videoContainer.classList.add('keyart__vimeo--mobile');
    } else if (!isMobileViewport && !videoContainer.classList.contains('keyart__vimeo--desktop')) {
        // console.debug("Setting keyart video - desktop")
        videoContainer.innerHTML = "";
        videoContainer.append(desktopVideoTemplate.content.cloneNode(true));
        videoContainer.classList.remove('keyart__vimeo--mobile');
        videoContainer.classList.add('keyart__vimeo--desktop');
    }
}

function setKeyartImage(imageContainer) {
    let isMobileViewport = jQuery(document).width() < 768;
    let mobileSrc = imageContainer.dataset.akaSrcMobile;
    let desktopSrc = imageContainer.dataset.akaSrcDesktop;

    if (isMobileViewport && imageContainer.src != mobileSrc) {
        // console.debug('Setting keyart image - mobile')
        imageContainer.src = mobileSrc;
        imageContainer.srcset = imageContainer.dataset.akaSrcsetMobile;
    } else if (!isMobileViewport && imageContainer.src != desktopSrc) {
        // console.debug("Setting keyart image - desktop")
        imageContainer.src = desktopSrc;
        imageContainer.srcset = imageContainer.dataset.akaSrcsetDesktop;
    }
}

function debounce(func, timeout = 250) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(this, args);
        }, timeout);
    };
}
